import * as React from 'react'
import classNames from 'classnames'

import Share from 'ui-component-library/icons/share.svg'
import Play from 'ui-component-library/icons/play.svg'

import Link from 'content-components/_Primatives/Link'

import style from './style.scss'

export type ArticleSource = 'internal' | 'external'

type Props = {
  articleSource: ArticleSource
  children: React.ReactNode
  className?: string
  isVideo?: boolean
  target?: string
  url: string
}

ArticleLink.defaultProps = {
  className: '',
  isVideo: false,
}

const INTERNAL = 'internal'

function ArticleLink(props: Props) {
  const { articleSource, children, className, isVideo, url, target } = props

  const renderIcon = () => {
    switch (true) {
      case articleSource !== INTERNAL: {
        return <Share className={style.shareIcon} data-testid='share' />
      }
      case isVideo: {
        return <Play className={style.playIcon} data-testid='play' />
      }
      default: {
        return null
      }
    }
  }

  return (
    <Link
      className={classNames(style.articleLink, className)}
      target={target}
      url={url}
    >
      {children}
      {renderIcon()}
    </Link>
  )
}

export default ArticleLink
